<template>
  <v-layout class="grey lighten-3">
    <v-container fluid class="py-0" grid-list-md>
      <v-flex xs12 class="pa-4" v-if="lAction === 'view'">
        <v-layout row wrap>
          <v-flex xs3>
            <v-card @click="appUsageMetrics()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-apps</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>App Usage <br>Metrics</br></strong></div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card @click="ProjectContractMetrics()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-format-indent-increase</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>Project Contract <br>Metrics<br/></strong></div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card @click="ProjectBillingMetrics()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-playlist-check</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>Project Billing <br>Metrics<br/></strong></div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card @click="UniformTrackingMetricsFirstLoad()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-account-multiple</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>Uniform Tracking <br>Metrics<br/></strong></div>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs3>
            <v-card @click="BackofficeSupportMetricsFirstLoad()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-crosshairs-gps</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>Back Office Support<br>Metrics<br/></strong></div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card @click="empAttritionMetrics()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-apps</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-4" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>HR Metrics</strong></div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card @click="PPMSummaryMetrics()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-calendar</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>PPM Summary</strong></div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- 1.0 App usage metrics -->
      <v-flex v-if="lAction === 'app-usage-metrics'" class="grey lighten-3 mt-2">
        <v-card flat>
          <v-card-title class="pb-3 grey lighten-4 primary--text">
            <v-layout row wrap>
              <v-layout row wrap>
                <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <v-flex xs2 sm3>Usage Metrics</v-flex>
                <v-flex xs8>
                  <v-layout row wrap>
                    <v-flex xs4 sm3 class="ml-10" style="margin-top: -10px;">
                      <v-dialog ref="dlgFromDate"
                      persistent v-model="dlgFromDate"
                      max-width="290px"
                      :return-value.sync="lDateFrom">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="From"
                          v-model="lDateFrom" append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="lDateFrom"
                        first-day-of-week="1">
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgFromDate = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgFromDate.save(lDateFrom)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs3 sm3 class="ml-2" style="margin-top: -10px;">
                      <v-dialog ref="dlgToDate"
                      persistent v-model="dlgToDate"
                      max-width="290px"
                      :return-value.sync="lDateTo">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="To"
                          v-model="lDateTo" append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="lDateTo"
                        first-day-of-week="1">
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgToDate = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgToDate.save(lDateTo)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs2 class="text-left ml-5">
                      <v-btn small fab class="accent" @click.native="loadUsageMetricGraphForSmartilityAndBB(lDateFrom, lDateTo)">Go</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <!-- top 10 screens for smartility and backbone graph view -->
            <v-flex xs12>
              <v-layout row wrap class="pt-5">
                <v-flex xs12 sm6 class="pt-12">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #E91E63"
                          class="elevation-0"
                          rounded="xl"
                          >
                            <div id="div_usageMetrics" class="elevation-7 pa-3" >
                              <canvas id="chart_usageMetrics"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 16px; color: #555555; line-height: 1.4em">Smartility Top 10 Screens</div>
                              <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #999999; line-height: 1.4em">Accessed at Smartility</div>
                              <div class="pt-3" > <hr></hr></div>
                              <template>
                                <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 13px; color: #999999; line-height: 1.4em">
                                  <v-icon class="mr-1" small>mdi-clock</v-icon>Updated on   {{loaded_date}}</div>
                              </template>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 class="pt-12">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px;"
                          class="elevation-0 success"
                          >
                            <div id="div_usageMetrics_bb" class="elevation-7 pa-3" >
                              <canvas id="chart_usageMetrics_bb"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 16px; color: #555555; line-height: 1.4em">Backbone Top 10 Screens</div>
                              <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #999999; line-height: 1.4em">Accessed at Backbone</div>
                              <div class="pt-3" > <hr></hr></div>
                              <template>
                                <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 13px; color: #999999; line-height: 1.4em">
                                  <v-icon class="mr-1" small>mdi-clock</v-icon>Updated on   {{loaded_date}}</div>
                              </template>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- top 10 screens for samrtility and backbone table view -->
            <v-expansion-panels class="pt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-flex class="subtitle font-weight-bold primary--text">
                    Top 10 Screens
                  </v-flex>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-card>
                        <v-card-title class="pa-1 tertiary white--text">
                          <div class="subtitle-1 text-center font-weight-bold">Smartility</div>
                        </v-card-title>
                        <v-card-text class="pa-0">
                          <v-data-table
                          :headers="screenHead"
                          :items="top10SmartScreens"
                          fixed-header
                          hide-default-footer
                          disable-pagination
                          :mobile-breakpoint="0">
                            <template slot="item" slot-scope="props">
                              <tr @click="loadScreenSMDet(props.item)">
                                <td>{{ props.item.s_no }}</td>
                                <td>{{ props.item.screen_name }}</td>
                                <td>{{ props.item.tot_screen_count }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-card>
                        <v-card-title class="pa-1 primary white--text">
                          <div class="subtitle-1 text-center font-weight-bold">Backbone</div>
                        </v-card-title>
                        <v-card-text class="pa-0">
                          <v-data-table
                          :headers="screenHead"
                          :items="top10BBScreens"
                          fixed-header
                          hide-default-footer
                          disable-pagination
                          :mobile-breakpoint="0">
                            <template slot="item" slot-scope="props">
                              <tr @click="loadScreenBBDet(props.item)">
                                <td>{{ props.item.s_no }}</td>
                                <td>{{ props.item.screen_name }}</td>
                                <td>{{ props.item.tot_screen_count }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- Top 10 user for smartility and backbone -->
            <v-expansion-panels class="pt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-flex class="subtitle font-weight-bold primary--text">
                    Top 10 Users
                  </v-flex>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-card>
                        <v-card-title class="pa-1 tertiary white--text">
                          <div class="subtitle-1 text-center font-weight-bold">Smartility</div>
                        </v-card-title>
                        <v-card-text class="pa-0">
                          <v-data-table
                          :headers="userSmHead"
                          :items="top10SmartUsers"
                          fixed-header
                          hide-default-footer
                          disable-pagination
                          :mobile-breakpoint="0">
                            <template slot="item" slot-scope="props">
                              <tr @click="loadSMUserDet(props.item)">
                                <td>{{ props.item.s_no }}</td>
                                <td>{{ props.item.cust_name }}</td>
                                <td>{{ props.item.tot_screen_count }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-card>
                        <v-card-title class="pa-1 primary white--text">
                          <div class="subtitle-1 text-center font-weight-bold">Backbone</div>
                        </v-card-title>
                        <v-card-text class="pa-0">
                          <v-data-table
                          :headers="userBBHead"
                          :items="top10BBUsers"
                          fixed-header
                          hide-default-footer
                          disable-pagination
                          :mobile-breakpoint="0">
                            <template slot="item" slot-scope="props">
                              <tr @click="loadBBUserDet(props.item)">
                                <td>{{ props.item.s_no }}</td>
                                <td>{{ props.item.emp_id }}</td>
                                <td>{{ props.item.emp_name }}</td>
                                <td>{{ props.item.tot_screen_count }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- search by user for smartility and backbone -->
            <v-expansion-panels class="pt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-flex class="subtitle primary--text font-weight-bold">
                    Search By Users
                  </v-flex>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-form ref="sForm" @submit.prevent="searchSmartUser()">
                        <v-card>
                          <v-card-title class="pa-1 tertiary white--text">
                            <div class="subtitle-1 text-center font-weight-bold">Smartility</div>
                          </v-card-title>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-combobox
                                v-model="lSmUser.user_pair"
                                label="Users"
                                :items="usersList"
                                item-text="cust_name_with_role"
                                item-value="cust_id"
                                hide-details
                                persistent-hint
                                clearable
                                ></v-combobox>
                              </v-flex>
                              <v-flex xs12>
                                <v-combobox
                                v-model="lSmUser.comm_pair"
                                label="Community"
                                :items="commList"
                                item-text="comm_name"
                                item-value="comm_id"
                                hide-details
                                persistent-hint
                                placeholder="All"
                                clearable
                                ></v-combobox>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex class="pt-4">
                                <v-btn class="mr-2" @click="clear">Clear</v-btn>
                                <v-btn class="mr-2" type="submit" color="accent" :disabled="beingSaved">search</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-form>
                    </v-flex>

                    <v-flex xs12 sm6>
                      <v-form ref="sForm" @submit.prevent="searchBBUser()">
                        <v-card>
                          <v-card-title class="pa-1 primary white--text">
                            <div class="subtitle-1 text-center font-weight-bold">BackBone</div>
                          </v-card-title>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 style="height: 112px;">
                                <v-combobox
                                v-model="lBBUser.emp_pair"
                                label="Employee"
                                item-value="emp_id"
                                item-text="emp_name_with_id"
                                :items="empList"
                                hide-details
                                persistent-hint
                                clearable
                                ></v-combobox>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex class="pt-4">
                                <v-btn class="mr-2" @click="clear">Clear</v-btn>
                                <v-btn class="mr-2" type="submit" color="accent" :disabled="beingSaved">search</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-form>
                    </v-flex>

                    <!--search results -->
                    <v-flex xs12>
                      <v-layout row wrap>
                        <!-- Smartility -->
                        <v-flex xs6 class="pt-2" grid-list-md v-if="userListSmart.length > 0">
                          <v-card-title class="pa-0">
                            <v-flex xs12 class="subtitle-1 font-weight-bold primary--text pa-1">
                              <span>Search Results ({{userListSmart.length}})</span>
                            </v-flex>
                          </v-card-title>
                          <v-card>
                            <v-card-text class="pa-0 ma-0">
                              <v-data-table
                              :headers="usersSmartHead"
                              :items="userListSmart"
                              hide-default-footer
                              disable-pagination
                              multi-sort
                              :mobile-breakpoint="0"
                              >
                                <template slot="item" slot-scope="props">
                                  <tr>
                                    <td>{{ props.item.s_no }}</td>
                                    <td>{{ props.item.cust_id }}</td>
                                    <td>{{ props.item.cust_name }}</td>
                                    <td>{{ props.item.comm_name }}</td>
                                    <td>{{ props.item.tot_screen_count }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <!-- Backbone -->
                        <v-flex xs6 v-if="userListSmart.length === 0"></v-flex>
                        <v-flex xs6 class="pt-2" grid-list-md v-if="userListBB.length > 0">
                          <v-card-title class="pa-0">
                            <v-flex xs12 class="subtitle-1 font-weight-bold primary--text pa-1">
                              <span>Search Results ({{ userListBB.length }})</span>
                            </v-flex>
                          </v-card-title>
                          <v-card>
                            <v-card-text class="pa-0 ma-0">
                              <v-data-table
                              :headers="usersBBHead"
                              :items="userListBB"
                              hide-default-footer
                              disable-pagination
                              multi-sort
                              :mobile-breakpoint="0"
                              >
                                <template slot="item" slot-scope="props">
                                  <tr>
                                    <td>{{ props.item.s_no }}</td>
                                    <td>{{ props.item.vendor_emp_id }}</td>
                                    <td>{{ props.item.emp_name }}</td>
                                    <td>{{ props.item.tot_screen_count }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- search by screen -->
            <v-expansion-panels class="pt-3">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-flex class="subtitle font-weight-bold primary--text">
                    Search By Screen
                  </v-flex>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-form ref="sForm" @submit.prevent="searchScreen()">
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs6 sm4>
                            <v-combobox
                            v-model="lScreen.app"
                            label="App"
                            :items="['Smartility', 'BackBone']"
                            persistent-hint
                            clearable
                            @click="loadScreenList()"
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs6 sm4>
                            <v-combobox
                            v-model="lScreen.screen_pair"
                            label="Screen Name"
                            :items="lScreen.app === 'Smartility' ? smartScreenList : bbScreenList"
                            item-text="screen_name"
                            item-value="screen_id"
                            return-object
                            hide-details
                            ></v-combobox>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex class="pt-4">
                            <v-btn class="mr-2" @click="clear">Clear</v-btn>
                            <v-btn class="mr-2" type="submit" color="accent" :disabled="beingSaved">search</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-form>

                  <!-- search results -->
                  <v-flex xs12 class="pt-2" grid-list-md v-if="searchResults.length > 0">
                    <v-card-title class="pa-0">
                      <v-flex xs12 class="subtitle-1 font-weight-bold primary--text pa-1">
                        <span>Search Results ({{searchResults.length}})</span>
                      </v-flex>
                    </v-card-title>
                    <v-card>
                      <v-card-text class="pa-0 ma-0">
                        <v-data-table
                        :headers="searchResultsHead"
                        :items="searchResults"
                        hide-default-footer
                        disable-pagination
                        multi-sort
                        :mobile-breakpoint="0"
                        >
                          <template slot="item" slot-scope="props">
                            <tr>
                              <td>{{ props.item.s_no }}</td>
                              <td>{{ props.item.emp_name }}</td>
                              <td>{{ props.item.comm_name }}</td>
                              <td>{{ props.item.tot_screen_count }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- total daily report mail graph view -->
            <v-flex xs12 class="subtitle-1 font-weight-bold primary--text pa-2">
              <v-layout row wrap>
                <v-flex xs6 class="pt-3">
                  Total Daily Report
                </v-flex>
                <v-flex xs6 class="text-right">
                  <v-btn class="accent" @click="ViewDailyReportMailStatus()">More</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap class="text-center">
                      <v-flex xs12 class="pa-2">
                        <v-layout row wrap class="text-center">
                          <v-flex xs12 sm6>
                            <div :id="'div_totReportMail_today'">
                              <canvas :id="'chart_totReportMail_today'"></canvas>
                            </div>
                            <v-flex class="subtitle font-weight-bold black--text">Total Sites : {{ totActiveProj }}</v-flex>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <div :id="'div_totReportMail_yest'">
                              <canvas :id="'chart_totReportMail_yest'"></canvas>
                            </div>
                            <v-flex class="subtitle font-weight-bold black--text">Total Sites : {{ totActiveProj }}</v-flex>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 1.1 Screen access detail for smartility -->
      <v-dialog v-model="showSMScreenDet" persistent scrollable max-width="800px">
        <v-card>
          <v-card-title class="title tertiary white--text font-weight-bold pa-2">
            <div>
              {{ screen_name }}
            </div>
            <v-spacer></v-spacer>
            <v-btn class="white--text" small icon @click.stop="showSMScreenDet = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="userHeadSm"
            :items="screenAccDetSM"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td>{{ props.item.s_no }}</td>
                  <td>{{ props.item.emp_name }}</td>
                  <td>{{ props.item.tot_screen_count }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 1.2 Screen access detail for backbone -->
      <v-dialog v-model="showScreenBBDet" persistent scrollable max-width="800px">
        <v-card>
          <v-card-title class="title primary white--text font-weight-bold pa-2">
            <div>
              {{ screen_name }}
            </div>
            <v-spacer></v-spacer>
            <v-btn class="white--text" small icon @click.stop="showScreenBBDet = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="userHead"
            :items="screenAccDetBB "
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td>{{ props.item.s_no }}</td>
                  <td>{{ props.item.emp_id }}</td>
                  <td>{{ props.item.emp_name }}</td>
                  <td>{{ props.item.tot_screen_count }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 1.3 Show user det-->
      <v-dialog v-model="showSMUserDet" persistent scrollable max-width="800px">
        <v-card>
          <v-card-title class="title tertiary white--text font-weight-bold pa-2">
            <div>
              {{ screen_name }}
            </div>
            <v-spacer></v-spacer>
            <v-btn class="white--text" small icon @click.stop="showSMUserDet = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="screenHead"
            :items="userDetSM"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td>{{ props.item.s_no }}</td>
                  <td>{{ props.item.screen_name }}</td>
                  <td>{{ props.item.tot_screen_count }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 1.4 Show user det for backbone-->
      <v-dialog v-model="showBBUserDet" persistent scrollable max-width="800px">
        <v-card>
          <v-card-title class="title primary white--text font-weight-bold pa-2">
            <div>
              {{ screen_name }}
            </div>
            <v-spacer></v-spacer>
            <v-btn class="white--text" small icon @click.stop="showBBUserDet = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="screenHead"
            :items="userDetBB"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td>{{ props.item.s_no }}</td>
                  <td>{{ props.item.screen_name }}</td>
                  <td>{{ props.item.tot_screen_count }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 1.5 Show daily report mail detail-->
      <v-dialog v-model="showdailyReportData" persistent scrollable max-width="900px">
        <v-card>
          <v-card-title class="title primary--text grey lighten-4 pa-2">
            <div>
              Daily Report Mail Detail
            </div>
            <v-spacer></v-spacer>
            <v-btn small icon @click.stop="showdailyReportData = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="mailDetHead"
            :items="dailyReportMailStatus"
            fixed-header
            :search="search"
            :height="450"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td>{{ props.item.s_no }}</td>
                  <td>{{ props.item.proj_name }}</td>
                  <td v-if="props.item.sent_yest === 'Yes'"><v-icon :color="props.item.sent_yest === 'Yes' ? 'success' : 'error'">mdi-check</v-icon></td>
                  <td v-else="props.item.sent_yest === 'No'"><v-icon :color="props.item.sent_yest === 'Yes' ? 'success' : 'error'">mdi-close</v-icon></td>
                  <td v-if="props.item.sent_today === 'Yes'"><v-icon :color="props.item.sent_today === 'Yes' ? 'success' : 'error'">mdi-check</v-icon></td>
                  <td v-else="props.item.sent_today === 'No'"><v-icon :color="props.item.sent_today === 'Yes' ? 'success' : 'error'">mdi-close</v-icon></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="grey lighten-4 caption">
            <v-layout>
              <v-flex xs6>
                <v-text-field
                append-icon="mdi-account-search"
                hide-details
                v-model="search"
                placeholder="Search"
                class="pa-2"
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                class="pt-3"
                :headers="mailDetHead"
                :items="dailyReportMailStatus"
                title="Daily Report Mail Status"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 2.0 show Project contract metrics-->
      <v-flex xs12 v-if="lAction === 'contract-metrics'">
        <v-card class="mt-2">
          <v-card-title class="pa-2 primary--text grey lighten-4">
            <v-layout row wrap>
              <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
              <v-flex>Project Contract Metrics</v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-download-as
            :headers="projectContractHeader"
            :items="projectContractList"
            title="Project Contract"
            :fontsize="8"
            ></v-download-as>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="projectContractHeader"
            :items="projectContractList"
            fixed-header
            dense
            height="550px"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            >
              <template slot="item" slot-scope="props">
                <tr :class="props.item.proj_name === 'Total' ? 'uniformchipinfo white--text font-weight-bold' : ''">
                  <td style="font-size: 12px;">{{ props.item.serial_no }}</td>
                  <td style="font-size: 12px;">{{ props.item.proj_name }}</td>
                  <td class="text-right pr-0" style="font-size: 12px;">{{ props.item.tot_manpower }}</td>
                  <td class="text-right pr-0" style="font-size: 12px;">{{ handy.formatCur(props.item.manpower_cost) }}</td>
                  <td class="text-right pr-0" style="font-size: 12px;">{{ handy.formatCur(props.item.service_cost) }}</td>
                  <td class="text-right pr-0" style="font-size: 12px;">{{ handy.formatCur(props.item.mgmt_fee) }}</td>
                  <td class="text-right pr-0" style="font-size: 12px;">{{ handy.formatCur(props.item.total_cost) }}</td>
                  <td class="text-right pr-0" style="font-size: 12px;">{{ handy.formatCur(props.item.gst) }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.grand_total) }}</td>
                  <td style="font-size: 12px;" :class="props.item.contract_end_date ? (new Date(props.item.contract_end_date) - Date.parse(today))/86400000 < 0 ? 'red white--text text-center' : (new Date(props.item.contract_end_date) - new Date(sixtydays))/86400000 > 60 ? 'green white--text text-center' : ((new Date(props.item.contract_end_date) - Date.parse(today))/86400000 > 0) && ((new Date(sixtydays) - new Date(props.item.contract_end_date))/86400000 < 60) ? 'yellow text-center' : '' : ''">{{ props.item.contract_end_date ? handy.formatDate(props.item.contract_end_date) : '' }}</td>
                  <td class="pa-1" @click="loadDetailInfoForselectedProj(props.item)"><v-btn v-if="props.item.proj_name !== 'Total'" small icon><v-icon class="black--text" small>mdi-information-outline</v-icon></v-btn></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 2.1 Show project contract detailed info for selected contract-->
      <v-dialog v-model="showDetailInfo" max-width="900px" scrollable>
        <v-card>
          <v-card-title class="primary--text grey lighten-3 py-2">
            {{detailInfo.proj_name}} {{detailInfo.contract_end_date}}
            <v-spacer></v-spacer>
            <v-btn small icon @click="showDetailInfo = false"><v-icon small>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-3">
            <v-data-table
            :headers="detailDataList"
            :items="detailInfoForSelectedProj"
            dense
            hide-default-footer
            disable-pagination
            class="elevation-2"
            :mobile-breakpoint="0"
            >
              <template slot="item" slot-scope="props">
                <tr :class="props.item.staff_role === 'Total' ? 'uniformchipinfo white--text' : ''">
                  <td style="font-size: 12px;">{{ props.item.serial_no }}</td>
                  <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                  <td style="font-size: 12px;">{{ props.item.head_count }}</td>
                  <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.amount) }}</td>
                  <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.mgmt_fee_amt) }}</td>
                  <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.before_gst_amt) }}</td>
                  <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.gst_amt) }}</td>
                  <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.total_amt) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 3.0 show Project billing metrics-->
      <v-flex xs12 v-if="lAction === 'billing-metrics'" class="mt-2">
        <v-card>
          <v-card-title class="pa-2 primary--text grey lighten-4">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-flex>Project Billing Metrics</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs2 sm2 class="ml-6">
                  <v-dialog ref="dlgBillingMon"
                  persistent v-model="dlgBillingMon"
                  max-width="290px"
                  :return-value.sync="lbilling_monthAndYear">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator" label="Bill Month &amp; Year"
                      v-model="lbilling_monthAndYear" append-icon="mdi-calendar-today"
                      readonly v-on="on" hide-details clearable
                      outlined dense color="primary" style="font-size: 12px"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="lbilling_monthAndYear" type="month"
                    first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgBillingMon = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgBillingMon.save(lbilling_monthAndYear)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs1>
                  <v-btn fab small class="accent" @click="loadProjectBilling()">Go</v-btn>
                </v-flex>
                <v-flex xs2>
                  <v-btn small class="accent" @click="ProjectUnBilledMetrics()">Unbilled Projects</v-btn>
                </v-flex>
                <v-flex xs3 class="ml-12">
                  <v-download-as
                  :headers="projectBillingHeader"
                  :items="projectBillingList"
                  :fontsize="8"
                  title="Project Billing"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="projectBillingHeader"
            :items="projectBillingList"
            fixed-header
            dense
            height="550px"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            >
              <template slot="item" slot-scope="props">
                <tr :class="props.item.proj_name === 'Total' ? 'uniformchipinfo white--text font-weight-bold' : ''">
                  <td style="font-size: 12px;">{{ props.item.serial_no }}</td>
                  <td style="font-size: 12px;">{{ props.item.proj_name }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.manpower_cost) }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.service_cost) }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.mgmt_fee) }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.total_cost) }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.gst) }}</td>
                  <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.grand_total) }}</td>
                  <td v-if="props.item.proj_name !== 'Total'" style="font-size: 12px;" class="text-right">
                    <v-btn @click="loadBillingComparison(props.item)" icon small><v-icon>mdi-compare-vertical</v-icon></v-btn>
                  </td>
                  <td v-else></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 3.1 Show project billing comparison details-->
      <v-dialog v-model="showComparisonData" max-width="1200px" scrollable>
        <v-flex xs12>
          <v-card>
            <v-card-title class="primary--text grey lighten-3 py-2">
              {{projectBill.proj_name}} - {{projectBill.current_month.substring(0,8)}}
              <v-spacer></v-spacer>
              <v-btn icon small @click="showComparisonData = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-3">
              <v-flex xs12>
                <v-data-table
                hide-default-header
                :headers="comparisonDataList"
                :items="comparisonDataList"
                dense
                hide-default-footer
                disable-pagination
                class="elevation-2"
                :mobile-breakpoint="0"
                >
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <td colspan="6" style="background-color: #c23dad; color: #fff; font-size: 12px; font-weight: bold;" class="text-center">Month wise billing value</td>
                        <td colspan="2" class="text-center" style="border-left: 1px solid black; background-color: #c23dad; color: #fff; font-size: 12px; font-weight: bold;">Comparison</td>
                      </tr>
                      <tr>
                        <th style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].sr_no}}</th>
                        <th style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].staff_role}}</th>
                        <th class="text-right pr-2" style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].previous_month_billed_amt}}</th>
                        <th class="text-right" :style="projectBill.current_month === headers[0].current_month_billed_amt ? 'background-color: #B8BB26; color: #fff; font-size: 12px; padding-right: 4px; font-weight: 800;' : 'background-color: #4570d6; color: #fff; font-size: 12px; padding-right: 0px;'">{{headers[0].current_month_billed_amt}}</th>
                        <th class="text-right pr-2" style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].next_month_billed_amt}}</th>
                        <td style="width: 5px; background-color: #4570d6;"></td>
                        <th class="text-right px-0" style="background-color: #4570d6; color: #fff; font-size: 12px; border-left: 1px solid black;">{{headers[0].first_comparison}}</th>
                        <th class="text-right" style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].sec_comparison}}</th>
                      </tr>
                    </thead>
                  </template>
                  <template slot="item" slot-scope="props">
                    <tr v-if="props.index > 0" :style="props.item.staff_role === 'Total' ? 'background-color: #44cb82; color: #fff; font-weight: bold; font-size: 12px;' : 'font-size: 10px;'">
                      <td style="font-size: 12px;" v-if="props.item.staff_role !== 'Total'">{{ props.index }}</td>
                      <td v-else></td>
                      <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                      <td style="font-size: 12px;" :class="'text-right pr-2'">{{ handy.formatCur(parseInt(props.item.previous_month_billed_amt)) }}</td>
                      <td style="font-size: 12px;" :class="'text-right pr-2'" :style="props.item.staff_role === 'Total' ? '' : 'background-color: #E9FFB8; font-weight: bold;'">{{ handy.formatCur(parseInt(props.item.current_month_billed_amt)) }}</td>
                      <td style="font-size: 12px;" :class="'text-right pr-2'">{{ handy.formatCur(parseInt(props.item.next_month_billed_amt)) }}</td>
                      <td style="width: 5px;"></td>
                      <td :class="props.item.first_comparison < 0 ? 'text-right red--text pl-0' : 'text-right pl-0'" style="border-left: 1px solid black; font-size: 12px;">{{ handy.formatCur(parseInt(props.item.first_comparison)) }}</td>
                      <td style="font-size: 12px;" :class="props.item.sec_comparison < 0 ? 'text-right red--text' : 'text-right'">{{ handy.formatCur(parseInt(props.item.sec_comparison)) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 class="pt-2">
                <table width="100%" cellpadding="0" cellspacing="0">
                  <tr>
                    <td style="width: 75px;"></td>
                    <td class="subheading">
                      <v-chip small style="background-color:#4EA9D0; font-size: 12px; color:#fff;">
                        <span v-if="projectBill.prev_comp === 'Infinity'">{{projectBill.prev_month}} month bill is not raised</span>
                        <span v-else>{{projectBill.current_month}} month invoice value is {{(projectBill.current_month_billed_amt - projectBill.previous_month_billed_amt) > 0 ? 'increased' : 'decreased'}} Rs {{projectBill.prev_comp}} % by comparing {{projectBill.prev_month}}</span>
                      </v-chip>
                    </td>
                    <td style="width: 75px;"></td>
                    <td class="subheading">
                      <v-chip small style="background-color:#4EA9D0; font-size: 12px; color:#fff;">
                        <span v-if="projectBill.next_comp === 'Infinity'">{{projectBill.next_month}} month bill is not raised</span>
                        <span v-else>{{projectBill.current_month}} month invoice value is {{(projectBill.current_month_billed_amt - projectBill.next_month_billed_amt) > 0 ? 'increased' : 'decreased'}} Rs {{projectBill.next_comp}} % by comparing {{projectBill.next_month}}</span>
                      </v-chip>
                    </td>
                    <td style="width: 75px;"></td>
                  </tr>
                </table>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-dialog>

      <!-- 3.1 Show Un-billed Projects metrics-->
      <v-flex xs12 v-if="lAction === 'Unbilled-metrics'" class="mt-2">
        <v-card>
          <v-card-title class="pa-2 primary--text grey lighten-4">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-btn class="pt-3" small icon @click="lAction = 'billing-metrics'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-flex>Project Un-Billed Metrics</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1>
                </v-flex>
                <v-flex xs2 sm2 class="ml-6">
                  <v-dialog ref="dlgUnBilledMon"
                  persistent v-model="dlgUnBilledMon"
                  max-width="290px"
                  :return-value.sync="lUnBilled_monthAndYear">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator" label="Bill Month &amp; Year"
                      v-model="lUnBilled_monthAndYear" append-icon="mdi-calendar-today"
                      readonly v-on="on" hide-details clearable
                      outlined dense color="primary" style="font-size: 12px"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="lUnBilled_monthAndYear" type="month"
                    first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgUnBilledMon = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgUnBilledMon.save(lUnBilled_monthAndYear)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs1>
                  <v-btn fab small class="accent" @click="loadUnBilledProjectList()">Go</v-btn>
                </v-flex>
                <v-flex xs1>
                </v-flex>
                <v-flex xs3 class="ml-12">
                  <v-download-as
                  :headers="projectUnBilledHeader"
                  :items="projectUnBilledList"
                  :fontsize="8"
                  title="Un-Billed Projects"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="projectUnBilledHeader"
            :items="projectUnBilledList"
            fixed-header
            dense
            height="550px"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            >
            <template slot="item" slot-scope="props">
              <tr :class="props.item.proj_name === 'Total' ? 'uniformchipinfo white--text font-weight-bold' : ''">
                <td style="font-size: 12px;">{{ props.item.serial_no }}</td>
                <td style="font-size: 12px;">{{ props.item.proj_name }}</td>
                <td style="font-size: 12px;">{{ props.item.bill_no }}</td>
                <td style="font-size: 12px;">{{ props.item.billing_status }}</td>
                <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.manpower_cost) }}</td>
                <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.service_cost) }}</td>
                <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.mgmt_fee) }}</td>
                <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.total_cost) }}</td>
                <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.gst) }}</td>
                <td class="text-right" style="font-size: 12px;">{{ handy.formatCur(props.item.grand_total) }}</td>
              </tr>
            </template>
          </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 4.0 Uniform tracking metrics -->
      <v-flex v-if="lAction === 'uniform-metrics'" class="grey lighten-3 mt-2">
        <v-card flat>
          <v-card-title class="pb-3 grey lighten-4 primary--text">
            <v-layout row wrap>
              <v-layout row wrap>
                <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <v-flex>Uniform Tracking Metrics</v-flex>
                <v-flex xs8>
                  <v-layout row wrap>
                    <v-flex xs4 sm3 class="ml-10" style="margin-top: -10px;">
                      <v-dialog ref="dlgUniformFromDate"
                      persistent v-model="dlgUniformFromDate"
                      max-width="290px"
                      :return-value.sync="lDateUniformFrom">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="From"
                          v-model="lDateUniformFrom" append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details>
                        </v-text-field>
                        </template>
                        <v-date-picker v-model="lDateUniformFrom"
                        first-day-of-week="1">
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgUniformFromDate = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgUniformFromDate.save(lDateUniformFrom)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs3 sm3 class="ml-2" style="margin-top: -10px;">
                      <v-dialog ref="dlgUniformToDate"
                      persistent v-model="dlgUniformToDate"
                      max-width="290px"
                      :return-value.sync="lDateUniformTo">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="To"
                          v-model="lDateUniformTo" append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="lDateUniformTo"
                        first-day-of-week="1">
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgUniformToDate = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgUniformToDate.save(lDateUniformTo)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs2 class="text-left ml-5">
                      <v-btn small fab class="accent" @click.native="loadUniformMetricsData()">Go</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap class="pt-5">
                <v-flex xs12 sm6 class="pt-12">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          rounded="xl"
                          >
                            <div id="div_uniformPurVsDistTrend" class="elevation-7 pa-3" >
                              <canvas id="chart_uniformPurVsDistTrend"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555; line-height: 1.4em">Uniform Purchase and Distribution Trend for last 6 months</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap class="pt-5">
                <v-flex xs12 sm6 class="pt-12">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor:#26A69A"
                          class="elevation-0"
                          >
                            <div id="div_uniformDistTrendTop10Projects" class="elevation-7 pa-3" >
                              <canvas id="chart_uniformDistTrendTop10Projects"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555; line-height: 1.4em">Top 10 Projects Uniform Distribution Trend for Selected Period</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 class="pt-12">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor:#26A69A"
                          class="elevation-0"
                          >
                            <div id="div_uniformDistTrendTop10SubCat" class="elevation-7 pa-3" >
                              <canvas id="chart_uniformDistTrendTop10SubCat"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 12px; color: #555555; line-height: 1.4em">Top 10 Uniform Sub-Category Wise Distribution Trend for Selected Period</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 5.0 Back office support metrics -->
      <v-flex v-if="lAction === 'backoffice-metrics'" class="grey lighten-3 mt-2">
        <v-card flat>
          <v-card-title class="pb-3 grey lighten-4 primary--text">
            <v-layout row wrap>
              <v-layout row wrap>
                <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <v-flex>Back Office Support Metrics</v-flex>
                <v-flex xs8>
                  <v-layout row wrap>
                    <v-flex xs4 sm3 class="ml-10" style="margin-top: -10px;">
                      <v-dialog ref="dlgBOFromDate"
                      persistent v-model="dlgBOFromDate"
                      max-width="290px"
                      :return-value.sync="lDateBOFrom">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="From"
                          v-model="lDateBOFrom" append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details>
                        </v-text-field>
                        </template>
                        <v-date-picker v-model="lDateBOFrom"
                        first-day-of-week="1">
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgBOFromDate = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgBOFromDate.save(lDateBOFrom)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs3 sm3 class="ml-2" style="margin-top: -10px;">
                      <v-dialog ref="dlgBOToDate"
                      persistent v-model="dlgBOToDate"
                      max-width="290px"
                      :return-value.sync="lDateBOTo">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="To"
                          v-model="lDateBOTo" append-icon="mdi-calendar-today"
                          readonly clearable
                          v-on="on"
                          hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="lDateBOTo"
                        first-day-of-week="1">
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgBOToDate = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgBOToDate.save(lDateBOTo)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs2 class="text-left ml-5">
                      <v-btn small fab class="accent" @click.native="loadBackOfficeMetricsData()">Go</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pt-8 mt-5" v-for="(deptName, n) in BODashDeptWise" :key="n">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div :id="'div_chartBODashDeptWise_' + deptName.dept_name.split(' ').join('_')" class="elevation-7 pa-3" >
                              <canvas :id="'chart_chartBODashDeptWise_' + deptName.dept_name.split(' ').join('_')"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em"><span style="font-weight: bold;">{{ deptName.dept_name }}</span> Department Wise Ticket Trend for Last 6 Months</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 6.0 HR Dashboard -->
      <v-container v-if="lAction === 'tot-emp'" class="pa-0" fluid grid-list-md>
        <v-card flat class="pa-0">
          <v-card-title class="title pb-0">
            <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
            HR Metrics
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForTotalEmp" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForTotalEmp"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Month Wise Attrition <span style="font-size: 16px; color: #C62828;"><strong> % </strong></span> for last 6 months</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm3 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #26A69A"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForTotalMaleFemale" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForTotalMaleFemale"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Total Male and Female counts</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm3 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #26A69A"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForTotalMaleFemalePercentage" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForTotalMaleFemalePercentage"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Total Male and Female percent</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForTotalNewEmpAndLeftEmp" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForTotalNewEmpAndLeftEmp"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Total New and Left Employee for last 6 months</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #26A69A"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForTotalEmpBasedOnRoleCat" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForTotalEmpBasedOnRoleCat"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Role Category Wise Total Employee</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="pt-4 px-0">
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-flex xs3 class="text-right">
                  <v-card @click="loadCategoryWiseAttrition()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
                    <v-list-item>
                      <v-sheet
                      elevation="2"
                      height="75"
                      width="75"
                      class="orange"
                      style="margin-top: 6px; margin-left: -5px;">
                      <v-icon large color="white" class="pa-5">mdi-apps</v-icon>
                      </v-sheet>
                    </v-list-item>
                    <div class="mr-4" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 13px; color: #ffffff"><strong>Category Wise Attrition</strong></div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-container>

      <!-- 6.1 HR Dashboard - Category wise attrition details -->
      <v-container v-if="lAction === 'category-Attrition'" class="pa-0" fluid grid-list-md>
        <v-card flat class="pa-0">
          <v-card-title class="title pb-0">
            <v-btn small icon @click="goBack()"><v-icon>mdi-arrow-left</v-icon></v-btn>
            Category wise Attrition
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForLeftAndNewEmpofManagement" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForLeftAndNewEmpofManagement"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Month Wise Attrition for MANAGEMENT/OFFICE</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForLeftEmpofSoft" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForLeftEmpofSoft"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Month Wise Attrition for SOFT SERVICES</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForLeftEmpofTech" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForLeftEmpofTech"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Month Wise Attrition for TECHNICAL SERVICES</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForLeftEmpofSafety" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForLeftEmpofSafety"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Month Wise Attrition for SAFTY/SECURITY</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pt-8 mt-5">
                  <v-card class="elevation-6">
                    <v-card-text>
                      <v-layout row wrap class="pl-0 pr-0 text-center">
                        <v-flex>
                          <v-sheet
                          style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                          class="elevation-0"
                          >
                            <div id="div_chartDataForLeftEmpofOther" class="elevation-7 pa-3" >
                              <canvas id="chart_chartDataForLeftEmpofOther"></canvas>
                            </div>
                          </v-sheet>
                        </v-flex>
                      </v-layout>
                      <v-layout xs12 row wrap class="text-center">
                        <v-flex>
                          <v-layout row wrap class="pl-3 pr-1 text-left">
                            <v-flex>
                              <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Month Wise Attrition for OTHER SERVICES</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-container>

      <!-- 7.0 PPM Summary details -->
      <v-flex xs12 v-if="lAction === 'ppmsummary-metrics'" class="mt-2">
        <v-card>
          <v-card-title class="pa-2 primary--text grey lighten-4">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-layout row wrap>
                    <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-flex>52 Weeks PPM Summary</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex  xs3 class="pt-3" v-if="isClosedProject === false">
                  <v-autocomplete
                  v-model="curComm"
                  label="Community"
                  :items="commList"
                  item-text="comm_name"
                  item-value="comm_id"
                  placeholder="Select Community"
                  @input="curComm ? loadPPMSummaryBasedOnComm(curComm) : ''"
                  outlined
                  dense
                  style="font-size: 12px"
                  ></v-autocomplete>
                </v-flex>
                <v-flex  xs3 class="pt-3" v-if="isClosedProject === true">
                  <v-autocomplete
                  v-model="curComm"
                  label="Community"
                  :items="closedProjCommList"
                  item-text="comm_name"
                  item-value="comm_id"
                  placeholder="Select Community"
                  @input="curComm ? loadPPMSummaryBasedOnComm(curComm) : ''"
                  outlined
                  dense
                  style="font-size: 12px"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs2 class="text-right pt-4">
                  <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
                </v-flex>
                <v-flex xs2 class="pt-4">
                  <v-download-as
                  :headers="ppmSummayHeader"
                  :items="ppmSummaryList"
                  :fontsize="8"
                  title="PPM Summary"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="ppmSummayHeader"
            :items="ppmSummaryList"
            fixed-header
            dense
            height="550px"
            hide-default-header
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 55px; text-align: center">{{headers[0].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[1].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[2].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[3].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[4].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[5].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[6].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[7].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[8].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[9].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[10].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[11].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr :class="props.item.proj_name === 'Total' ? 'uniformchipinfo white--text font-weight-bold' : ''">
                  <td class="text-center" style="font-size: 12px;">{{ props.index + 1 }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.asset_type ? props.item.asset_type : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.asset_cat ? props.item.asset_cat : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.asset_id ? props.item.asset_id : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.asset_name ? props.item.asset_name : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.ppm_seq_id ? props.item.ppm_seq_id : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.ppm_title ? props.item.ppm_title : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.frequency ? props.item.frequency : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.duration_years ? props.item.duration_years : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.No_of_Ppms ? props.item.No_of_Ppms : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.from_ppm_id ? props.item.from_ppm_id : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.to_ppm_id ? props.item.to_ppm_id : '-' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- snack bar for reporting -->
      <v-snackbar :color="sbarCol" v-model="sbar"
      :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
      </v-snackbar>
    </v-container>
  </v-layout>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: 'view',
      sbarMsg: '',
      sbarCol: 'error',
      sbar: false,
      config: config,
      handy: handy,
      rules: handy.rules,
      dlgToDate: false,
      dlgFromDate: false,
      lDateFrom: '',
      lDateTo: '',
      dlgUniformFromDate: false,
      dlgUniformToDate: false,
      dlgBOFromDate: false,
      dlgBOToDate: false,
      lDateUniformFrom: '',
      lDateUniformTo: '',
      lDateBOFrom: '',
      lDateBOTo: '',
      usageMetricsForSmart: [],
      usageMetricsForBB: [],
      top10SmartScreens: [],
      top10BBScreens: [],
      top10BBUsers: [],
      top10SmartUsers: [],
      tmpChart: [],
      screenHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Screen Name', value: 'screen_name' },
        { text: 'Access Screen Count', value: 'tot_screen_count' },
      ],
      userSmHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Employee Name', value: 'cust_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' },
      ],
      userHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Employee Id', value: 'cust_id' },
        { text: 'Employee Name', value: 'cust_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' },
      ],
      userHeadSm: [
        { text: 'SNo', value: 's_no' },
        { text: 'Employee Name', value: 'cust_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' },
      ],
      userBBHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Employee Id', value: 'emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' },
      ],
      usersSmartHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Cust Id', value: 'cust_id' },
        { text: 'Customer Name', value: 'cust_name' },
        { text: 'Community Name', value: 'comm_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' }
      ],
      usersBBHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' }
      ],
      searchResultsHead: [
        { text: 'SNo', value: 's_no' },
        { text: 'Employee Name', value: 'cust_name' },
        { text: 'Community Name', value: 'comm_name' },
        { text: 'Screen Access Count', value: 'tot_screen_count' }
      ],
      lSmUser: {},
      lBBUser: {},
      beingSaved: false,
      userListSmart: [],
      userListBB: [],
      commList: [],
      curComm: '',
      empList: [],
      lScreen: {},
      smartScreenList: [],
      bbScreenList: [],
      searchResults: [],
      showSMScreenDet: false,
      showScreenBBDet: false,
      showSMUserDet: false,
      showBBUserDet: false,
      screenAccDetSM: [],
      screenAccDetBB: [],
      userDetSM: [],
      userDetBB: [],
      totActiveProj: '',
      totMailCountToday: [],
      totMailCountYest: [],
      dailyReportMailStatus: [],
      showdailyReportData: false,
      mailDetHead: [
        { text: 'SNo', value: 's_no', class: 'orange lighten-3' },
        { text: 'Project Name', value: 'proj_name', class: 'orange lighten-3' },
        { text: 'Yesterday', value: 'sent_yest', class: 'orange lighten-3' },
        { text: 'Today', value: 'sent_today', class: 'orange lighten-3' }
      ],
      search: '',
      screen_name: '',
      loaded_date: '',
      usersList: [],
      // project contract
      projectContractHeader: [
        { text: 'S No.', value: 'serial_no',class: 'uniformtableheader white--text pr-0', width: '46px', sortable: false },
        { text: 'Project Name', value: 'proj_name', class: 'uniformtableheader white--text', width: '160px', sortable: false },
        { text: 'Tot Manpower', value: 'tot_manpower', align: 'right', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Man Power Cost', value: 'manpower_cost', align: 'right', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Services Cost', value: 'service_cost', align: 'right', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Management Fee', value: 'mgmt_fee', align: 'right', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Revenue', value: 'total_cost', align: 'right', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'GST', value: 'gst', align: 'right', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Total Revenue', value: 'grand_total', align: 'right', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Contract End Date', value: 'contract_end_date', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: '', value: '', class: 'uniformtableheader white--text pr-0', sortable: false }
      ],
      projectContractList: [],
      detailInfoForSelectedProj: [],
      detailInfo: {
        proj_name: '',
        contract_end_date: null
      },
      showDetailInfo: false,
      detailDataList: [
        { text: 'S No.', value: 'serial_no',class: 'uniformtableheader white--text pr-0', width: '50px', sortable: false },
        { text: 'Role', value: 'staff_role', width: '180px', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Tot Hc', value: 'head_count', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Amount/Hc', value: 'amount', align: 'right', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Mgmt Amt', value: 'mgmt_fee_amt', align: 'right', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Amt before GST', value: 'before_gst_amt', align: 'right', class: 'uniformtableheader white--text', sortable: false },
        { text: 'GST', value: 'gst_amt', align: 'right', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Amt after GST', value: 'total_amt', align: 'right', class: 'uniformtableheader white--text', sortable: false }
      ],
      // project billing
      projectBillingHeader: [
        { text: 'S No.', value: 'serial_no',class: 'uniformtableheader white--text', sortable: false },
        { text: 'Project Name', value: 'proj_name', class: 'uniformtableheader white--text' },
        { text: 'Man Power Cost', value: 'manpower_cost', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Services Cost', value: 'service_cost', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Management Fee', value: 'mgmt_fee', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Total Cost', value: 'total_cost', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'GST', value: 'gst', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Grand Total', value: 'grand_total', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: '', value: '', align: 'right', class: 'uniformtableheader white--text pr-0' }
      ],
      projectBillingList: [],
      dlgBillingMon: false,
      lbilling_monthAndYear: null,
      // comparison data
      comparisonDataList: [],
      showComparisonData: false,
      projectBill: {
        proj_name: '',
        prev_comp: 0,
        prev_month: '',
        next_month: '',
        next_comp: 0,
        current_month: '',
        current_month_billed_amt: 0,
        previous_month_billed_amt: 0,
        next_month_billed_amt: 0
      },
      chartDataForUniformPurVsDistTrend: [],
      chartDataForTop10ProjectDistribution: [],
      chartDataForTop10SubCatDistribution: [],
      BODashDeptWise: [],
      chartDataForTotalEmp: [],
      chartDataForTotalMaleFemale: [],
      chartDataForTotalNewEmpAndLeftEmp: [],
      chartDataForTotalStaffBasedOnRoleCat: [],
      chartDataForLeftAndNewEmp: [],
      tmpChart: [],
      mgmtChart: [],
      chartDataForLeftEmpOfSoftService: [],
      chartDataForLeftEmpOfTechService: [],
      chartDataForLeftEmpOfSafetyService: [],
      chartDataForLeftEmpOfOtherService: [],
      // project un-billed
      dlgUnBilledMon: false,
      lUnBilled_monthAndYear: '',
      projectUnBilledHeader: [
        { text: 'S No.', value: 'serial_no',class: 'uniformtableheader white--text', sortable: false },
        { text: 'Project Name', value: 'proj_name', class: 'uniformtableheader white--text' },
        { text: 'Bill No', value: 'bill_no', class: 'uniformtableheader white--text' },
        { text: 'Bill Status', value: 'billing_status', class: 'uniformtableheader white--text' },
        { text: 'Man Power Cost', value: 'manpower_cost', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Services Cost', value: 'service_cost', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Management Fee', value: 'mgmt_fee', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Total Cost', value: 'total_cost', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'GST', value: 'gst', align: 'right', class: 'uniformtableheader white--text pr-0' },
        { text: 'Grand Total', value: 'grand_total', align: 'right', class: 'uniformtableheader white--text pr-0' }
      ],
      projectUnBilledList: [],
      ppmSummaryList: [],
      ppmSummayHeader: [
        { text: 'S No.', value: 'serial_no', align: 'center', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Type', value: 'asset_type', align: 'center', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Category', value: 'asset_cat', align: 'center', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Asset Id', value: 'asset_id', align: 'center', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Asset Name', value: 'asset_name', class: 'uniformtableheader white--text', sortable: false },
        { text: 'Seq.No', value: 'ppm_seq_id', align: 'center', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'PPM Title', value: 'ppm_title', align: 'left', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Frequency', value: 'frequency', align: 'center', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'Duration', value: 'duration_years', align: 'center', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'No.of.PPM', value: 'No_of_Ppms', align: 'center', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'From ID', value: 'from_ppm_id', align: 'center', class: 'uniformtableheader white--text pr-0', sortable: false },
        { text: 'To ID', value: 'to_ppm_id', align: 'center', class: 'uniformtableheader white--text pr-0', sortable: false }
      ],
      isClosedProject: false,
      closedProjCommList: []
    }
  },
  mounted () {
    var curDate = new Date()
    var curUniformDate = new Date()
    var curBODate = new Date()
    this.lDateTo = handy.formatDBDate(curDate)
    this.lDateFrom = handy.formatDBDate(curDate.setMonth(curDate.getMonth()-1))
    this.lDateUniformTo = handy.formatDBDate(new Date(curUniformDate.getFullYear(), curUniformDate.getMonth() + 1, 0))
    this.lDateUniformFrom = handy.formatDBDate(new Date(curUniformDate.getFullYear(), curUniformDate.getMonth() - 5, 1))
    this.lDateBOFrom = handy.formatDBDate(new Date(curBODate.getFullYear(), curBODate.getMonth() - 5, 1))
    this.lDateBOTo = handy.formatDBDate(new Date(curBODate.getFullYear(), curBODate.getMonth() + 1, 0))
  },
  computed: {
    sixtydays: function () {
      return new Date(new Date().getFullYear(), new Date().getMonth() + 2)
    },
    today: function () {
      return new Date()
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    appUsageMetrics () {
      this.loadUpdatedDateTime()
      this.loadUsageMetricGraphForSmartilityAndBB(this.lDateFrom, this.lDateTo)
      this.loadMailCountGraph ()
      this.lAction = 'app-usage-metrics'
      this.loadCommunity()
      this.loadClosedProjectCommunity()
      this.loadEmployee()
      this.loadUsers()
    },
    loadUsageMetricGraphForSmartilityAndBB (fromDate, toDate) {
      this.loadUpdatedDateTime ()
      var dates = []
      dates.push(fromDate + ' 00:00:00')
      dates.push(toDate + ' 23:59:59')
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          view_date_time: dates
        }
      }
      this.top10SmartScreens = []
      this.top10BBScreens = []
      this.top10BBUsers = []
      this.top10SmartUsers = []
      this.usageMetricsForBB = []
      this.usageMetricsForSmart = []
      this.axios.get(config.API_URL + '/getUsageMetricsForSmartilityAndBB/', qry)
      .then(response => {
        if (response.data.length) {
          this.usageMetricsForBB = response.data[0]
          this.usageMetricsForSmart = response.data[1]
          for (var i = 0; i < response.data[3].length; i++) {
            this.top10SmartScreens.push({
              s_no: i+1,
              screen_number: response.data[3][i].screen_number,
              screen_name: response.data[3][i].screen_name,
              tot_screen_count: response.data[3][i].tot_screen_count,
              app: response.data[3][i].app
            })
          }
          for (var i = 0; i < response.data[2].length; i++) {
            this.top10BBScreens.push({
              s_no: i+1,
              screen_id: response.data[2][i].screen_id,
              screen_name: response.data[2][i].screen_name,
              tot_screen_count: response.data[2][i].tot_screen_count,
              app: response.data[2][i].app
            })
          }
          for (var i = 0; i < response.data[4].length; i++) {
            this.top10BBUsers.push({
              s_no: i+1,
              emp_id: response.data[4][i].emp_id,
              emp_name: response.data[4][i].emp_name,
              tot_screen_count: response.data[4][i].tot_screen_count
            })
          }
          for (var i = 0; i < response.data[5].length; i++) {
            this.top10SmartUsers.push({
              s_no: i+1,
              cust_id: response.data[5][i].cust_id,
              comm_name: response.data[5][i].comm_name,
              comm_id: response.data[5][i].comm_id,
              cust_name: response.data[5][i].cust_name,
              tot_screen_count: response.data[5][i].tot_screen_count
            })
          }
        }
        setTimeout(() => {
          document.getElementById('div_usageMetrics').innerHTML = '<canvas id="chart_usageMetrics"></canvas>'
          var canvas = document.getElementById('chart_usageMetrics')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 250
          this.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: this.usageMetricsForSmart.map(rec =>rec.screen_name),
              datasets: [{
                backgroundColor: '#ffffff',
                borderColor: "rgba(219, 0, 0, 1)",
                data: this.usageMetricsForSmart.map(rec =>rec.tot_screen_count),
                fill: true
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value || ''
                  },
                  color: '#E91E63',
                  fontSize: 11,
                }
              },
              tooltips: {enabled: false},
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: '#ffffff'
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: "white",
                    zeroLineColor: "#E91E63"
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: '#ffffff',
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: "white"
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)

        document.getElementById('div_usageMetrics_bb').innerHTML = '<canvas id="chart_usageMetrics_bb"></canvas>'
        var canvas = document.getElementById('chart_usageMetrics_bb')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 250
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: this.usageMetricsForBB.map(rec =>rec.screen_name),
            datasets: [{
              backgroundColor: '#ffffff',
              data: this.usageMetricsForBB.map(rec =>rec.tot_screen_count),
              fill: true
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value || ''
                },
                color: '#00C853',
                fontSize: 11,
              }
            },
            tooltips: {enabled: false},
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0,
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#00C853"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white"
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    searchSmartUser () {
      if (!this.lSmUser.user_pair || !this.lSmUser.user_pair.cust_id) {
        this.userListSmart = []
        this.msg('Please select user from given list', 0)
      } else {
        var dates = []
        dates.push(this.lDateFrom + ' 00:00:00')
        dates.push(this.lDateTo + ' 23:59:59')
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID,
            cust_id: this.lSmUser.user_pair.cust_id,
            comm_name: this.lSmUser.comm_pair ? this.lSmUser.comm_pair.comm_name : null,
            view_date_time: dates
          }
        }
        this.userListSmart = []
        this.axios.get(config.API_URL + '/getSmartUserList/', qry)
        .then(response => {
          if (response.data.length) {
            for(var i = 0; i < response.data.length; i++) {
              this.userListSmart.push({
                s_no: i+1,
                cust_id: response.data[i].cust_id,
                cust_name: response.data[i].cust_name,
                comm_name: response.data[i].comm_name,
                tot_screen_count: response.data[i].tot_screen_count
              })
            }
          } else {
            this.msg('No records found with given search criteria', 0)
          }
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.userListSmart = []
          this.beingSaved = false
        })
      }
    },
    searchBBUser () {
      if (!this.lBBUser.emp_pair || !this.lBBUser.emp_pair.emp_id) {
        this.msg('Please select employee from given list', 0)
      } else {
        var dates = []
        dates.push(this.lDateFrom + ' 00:00:00')
        dates.push(this.lDateTo + ' 23:59:59')
        var qry = {
          params: {
            vendor_id:config.VENDOR_ID,
            emp_id: this.lBBUser.emp_pair.emp_id,
            view_date_time: dates
          }
        }
        this.userListBB = []
        this.axios.get(config.API_URL + '/getBBUserList/', qry)
        .then(response => {
          if (response.data.length) {
            for(var i = 0; i < response.data.length; i++) {
              this.userListBB.push({
                s_no: i+1,
                vendor_emp_id: response.data[i].vendor_emp_id,
                emp_name: response.data[i].emp_name,
                tot_screen_count: response.data[i].tot_screen_count
              })
            }
          } else {
            this.msg('No records found with given search criteria', 0)
          }
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.userListBB = []
          this.beingSaved = false
        })
      }
    },
    searchScreen () {
      if (!this.lScreen.app || !this.lScreen.screen_pair && !this.lScreen.screen_pair.screen_name) {
        this.msg('Please select screen app and screen name from given list', 0)
      } else {
        var dates = []
        dates.push(this.lDateFrom + ' 00:00:00')
        dates.push(this.lDateTo + ' 23:59:59')
        var qry = {
          params: {
            vendor_id:config.VENDOR_ID,
            app: this.lScreen.app,
            screen_name: this.lScreen.screen_pair.screen_name,
            view_date_time: dates
          }
        }
        this.searchResults = []
        this.axios.get(config.API_URL + '/searchByScreen/', qry)
        .then(response => {
          if (response.data.length) {
            if (qry.params.app === 'BackBone') {
              for(var i = 0; i < response.data.length; i++) {
                this.searchResults.push({
                  s_no: i+1,
                  emp_id: response.data[i].emp_id,
                  emp_name: response.data[i].emp_name,
                  comm_name: response.data[i].comm_name,
                  tot_screen_count: response.data[i].tot_screen_count
                })
              }
            } else {
              for(var i = 0; i < response.data.length; i++) {
                this.searchResults.push({
                  s_no: i+1,
                  emp_id: response.data[i].cust_id,
                  emp_name: response.data[i].cust_name,
                  comm_name: response.data[i].comm_name,
                  tot_screen_count: response.data[i].tot_screen_count
                })
              }
            }
          } else {
            this.msg('No records found with given search criteria', 0)
          }
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.searchResults = []
          this.beingSaved = false
        })
      }
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadClosedProjectCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.closedProjCommList = []
      this.axios.get(config.API_URL + '/getClosedProjectCommList/', qry)
      .then(response => {
        this.closedProjCommList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
    },
    loadEmployee () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.empList = []
      this.axios.get(config.API_URL + '/getBackOfficeStaffs/', qry)
      .then(response => {
        this.empList = response.data.filter(rec => rec.emp_status === 'On Job' || rec.emp_status === 'In Bench')
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.empList = []
        this.beingSaved = false
      })
    },
    loadScreenList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.smartScreenList = []
      this.bbScreenList = []
      this.axios.get(config.API_URL + '/getScreenList/', qry)
      .then(response => {
        this.smartScreenList = response.data.filter(rec =>rec.app === 'Smartility')
        this.bbScreenList = response.data.filter(rec =>rec.app === 'BackBone')
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.empList = []
        this.beingSaved = false
      })
    },
    loadScreenSMDet (curItem) {
      var dates = []
      dates.push(this.lDateFrom + ' 00:00:00')
      dates.push(this.lDateTo + ' 23:59:59')
      var qry = {
        params: {
          screen_number: curItem.screen_number,
          vendor_id: config.VENDOR_ID,
          view_date_time: dates
        }
      }
      this.screenAccDetSM = []
      this.axios.get(config.API_URL + '/getSMScreenDet/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.screenAccDetSM.push({
              s_no: i+1,
              emp_name: response.data[i].cust_name,
              tot_screen_count: response.data[i].tot_screen_count
            })
          }
        }
        this.beingSaved = false
        this.screen_name = curItem.screen_name + ' (' + curItem.tot_screen_count +')'
        this.showSMScreenDet = true
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    loadScreenBBDet (curItem) {
      var dates = []
      dates.push(this.lDateFrom + ' 00:00:00')
      dates.push(this.lDateTo + ' 23:59:59')
      var qry = {
        params: {
          screen_id: curItem.screen_id,
          vendor_id: config.VENDOR_ID,
          view_date_time: dates
        }
      }
      this.screenAccDetBB = []
      this.axios.get(config.API_URL + '/getBBScreenDet/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.screenAccDetBB.push({
              s_no: i+1,
              emp_id: response.data[i].emp_id,
              emp_name: response.data[i].emp_name,
              tot_screen_count: response.data[i].tot_screen_count
            })
          }
        }
        this.beingSaved = false
        this.screen_name = curItem.screen_name + ' (' + curItem.tot_screen_count +')'
        this.showScreenBBDet = true
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    loadSMUserDet (curItem) {
      var dates = []
      dates.push(this.lDateFrom + ' 00:00:00')
      dates.push(this.lDateTo + ' 23:59:59')
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          cust_id: curItem.cust_id,
          view_date_time: dates
        }
      }
      this.userDetSM = []
      this.axios.get(config.API_URL + '/getUserDetSM/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.userDetSM.push({
              s_no: i+1,
              screen_name: response.data[i].screen_name,
              comm_name: response.data[i].comm_name,
              tot_screen_count: response.data[i].tot_screen_count
            })
          }
        }
        this.beingSaved = false
        this.screen_name = curItem.cust_name + ' (' + curItem.tot_screen_count + ')'
        this.showSMUserDet = true
      })
      .catch(err => {
        this.msg(err)
        this.userDetSM = []
        this.beingSaved = false
      })
    },
    loadBBUserDet (curItem) {
      var dates = []
      dates.push(this.lDateFrom + ' 00:00:00')
      dates.push(this.lDateTo + ' 23:59:59')
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          emp_id: curItem.emp_id,
          view_date_time: dates
        }
      }
      this.userDetBB = []
      this.axios.get(config.API_URL + '/getUserDetBB/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.userDetBB.push({
              s_no: i+1,
              screen_name: response.data[i].screen_name,
              comm_name: response.data[i].comm_name,
              tot_screen_count: response.data[i].tot_screen_count
            })
          }
        }
        this.beingSaved = false
        this.screen_name = curItem.emp_name + ' (' + curItem.tot_screen_count + ')'
        this.showBBUserDet = true
      })
      .catch(err => {
        this.msg(err)
        this.userDetBB = []
        this.beingSaved = false
      })
    },
    loadActiveProjects () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.totActiveProj = []
      this.axios.get(config.API_URL + '/getActiveProjects/', qry)
      .then(response => {
        this.totActiveProj = response.data[0].tot_proj
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadUsers () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSMUsers/', qry)
      .then(response => {
        this.usersList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    ViewDailyReportMailStatus () {
      var curDate = new Date()
      var date = handy.formatDBDate(curDate)
      var yesterdayDate = handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      var qry = {
        params: {
          from_dt: date,
          to_dt: yesterdayDate,
          vendor_id: config.VENDOR_ID
        }
      }
      this.dailyReportMailStatus = []
      this.axios.get(config.API_URL + '/getDailyReportMailStatusByProj/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.dailyReportMailStatus.push({
              s_no: i+1,
              proj_name: response.data[i].proj_name,
              sent_today: response.data[i].sent_today,
              sent_yest: response.data[i].sent_yest
            })
          }
        }
        this.showdailyReportData = true
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadMailCountGraph () {
      this.loadActiveProjects()
      var curDate = new Date()
      var date = handy.formatDBDate(curDate)
      var yesterdayDate = handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      var qry = {
        params: {
          from_dt: date,
          to_dt: yesterdayDate
        }
      }
      this.axios.get(config.API_URL + '/getTotalDailyReportMailCount/', qry)
      .then(response => {
        this.totMailCountToday = response.data.map(rec => rec.total_count)[0]
        this.totMailCountYest = response.data.map(rec => rec.total_count)[1]
        if (response.data.length) {
          response.data.forEach(rec => {
            if (handy.formatDBDate(rec.date) === date) {
              var todayData = []
              todayData.push(rec.total_count)
              todayData.push(Number(this.totActiveProj - rec.total_count))
              document.getElementById('div_totReportMail_today').innerHTML = '<canvas id="chart_totReportMail_today"></canvas>'
              var canvas = document.getElementById('chart_totReportMail_today')
              var ctx = canvas.getContext('2d')
              ctx.canvas.height = 100
              this.tmpChart = new Chart(ctx, {
                type: 'polarArea',
                data: {
                  labels: ['Sent', 'Not Sent'],
                  datasets: [{
                    backgroundColor: ['#00C853', '#E91E63'],
                    data: todayData
                  }]
                },
                options: {
                  plugins: {
                    datalabels: {
                      formatter: function (value) {
                        return value > 0 ? value : ''
                      },
                      color: '#ffffff'
                    }
                  },
                  title: {
                    display: true,
                    text: 'Today',
                    fontSize: 16
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              })
            }
            if (handy.formatDBDate(rec.date) === yesterdayDate) {
              var yesterdayData = []
              yesterdayData.push(rec.total_count)
              yesterdayData.push(Number(this.totActiveProj - rec.total_count))
              document.getElementById('div_totReportMail_yest').innerHTML = '<canvas id="chart_totReportMail_yest"></canvas>'
              var canvas = document.getElementById('chart_totReportMail_yest')
              var ctx = canvas.getContext('2d')
              ctx.canvas.height = 100
              this.tmpChart = new Chart(ctx, {
                type: 'polarArea',
                data: {
                  labels: ['Sent', 'Not Sent'],
                  datasets: [{
                    backgroundColor: ['#00C853', '#E91E63'],
                    data: yesterdayData
                  }]
                },
                options: {
                  plugins: {
                    datalabels: {
                      formatter: function (value) {
                        return value > 0 ? value : ''
                      },
                      color: '#ffffff'
                    }
                  },
                  title: {
                    display: true,
                    text: 'Yesterday',
                    fontSize: 16
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              })
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadUpdatedDateTime () {
      var curDate = new Date()
      this.loaded_date = handy.formatDisplayDateTime(curDate)
    },
    clear () {
      this.$refs.sForm.reset()
      this.lSmUser = []
      this.lBBUser = []
      this.lScreen = []
      this.userListSmart.length = []
      this.userListBB.length = []
      this.searchResults = []
    },
    ProjectContractMetrics () {
      this.lAction = 'contract-metrics'
      this.loadProjectContract()
    },
    loadProjectContract () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      var tmpVar = {
        proj_name: '',
        tot_manpower: 0,
        manpower_cost: 0,
        service_cost: 0,
        mgmt_fee: 0,
        total_cost: 0,
        gst: 0,
        grand_total: 0,
        contract_end_date: ''
      }
      this.projectContractList = []
      this.axios.get(config.API_URL + '/getProjectContractDashboardList/', qry)
      .then(response => {
        if (response.data.length > 0) {
          for (var i = 0; i < response.data.length; i++) {
            this.projectContractList.push({
              serial_no: i+1,
              proj_contract_base_id: response.data[i].proj_contract_base_id,
              proj_name: response.data[i].proj_name,
              tot_manpower: response.data[i].tot_manpower,
              manpower_cost: response.data[i].manpower_cost,
              service_cost: response.data[i].service_cost,
              mgmt_fee: response.data[i].mgmt_fee,
              total_cost: response.data[i].total_cost,
              gst: response.data[i].gst,
              grand_total: response.data[i].grand_total,
              contract_end_date: response.data[i].contract_end_date
            })
            tmpVar.proj_name = 'Total'
            tmpVar.tot_manpower += parseFloat(response.data[i].tot_manpower)
            tmpVar.manpower_cost += parseFloat(response.data[i].manpower_cost)
            tmpVar.service_cost += parseFloat(response.data[i].service_cost)
            tmpVar.mgmt_fee += parseFloat(response.data[i].mgmt_fee)
            tmpVar.total_cost += parseFloat(response.data[i].total_cost)
            tmpVar.gst += parseFloat(response.data[i].gst)
            tmpVar.grand_total += parseFloat(response.data[i].grand_total)
          }
          this.projectContractList.push({
            serial_no: null,
            proj_name: tmpVar.proj_name,
            proj_contract_base_id: null,
            tot_manpower: tmpVar.tot_manpower.toFixed(2),
            manpower_cost: tmpVar.manpower_cost,
            service_cost: tmpVar.service_cost,
            mgmt_fee: tmpVar.mgmt_fee,
            total_cost: tmpVar.total_cost,
            gst: tmpVar.gst,
            grand_total: tmpVar.grand_total,
            contract_end_date: ''
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    ProjectBillingMetrics () {
      this.projectBillingList = []
      this.lAction = 'billing-metrics'
    },
    loadProjectBilling () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          billing_month: this.lbilling_monthAndYear.split('-')[1],
          billing_year: this.lbilling_monthAndYear.split('-')[0]
        }
      }
      var tmpVar = {
        proj_name: '',
        manpower_cost: 0,
        service_cost: 0,
        mgmt_fee: 0,
        total_cost: 0,
        gst: 0,
        grand_total: 0,
      }
      this.projectBillingList = []
      this.axios.get(config.API_URL + '/getProjectBillingDashboardList/', qry)
      .then(response => {
        if (response.data.length > 0) {
          for (var i = 0; i < response.data.length; i++) {
            this.projectBillingList.push({
              serial_no: i+1,
              proj_id: response.data[i].proj_id,
              proj_name: response.data[i].proj_name,
              manpower_cost: response.data[i].manpower_cost,
              service_cost: response.data[i].service_cost,
              mgmt_fee: response.data[i].Mgmt_fee,
              total_cost: response.data[i].total_cost,
              gst: response.data[i].gst,
              grand_total: response.data[i].grand_total
            })
            tmpVar.proj_name = 'Total'
            tmpVar.manpower_cost += parseFloat(response.data[i].manpower_cost)
            tmpVar.service_cost += parseFloat(response.data[i].service_cost)
            tmpVar.mgmt_fee += parseFloat(response.data[i].Mgmt_fee)
            tmpVar.total_cost += parseFloat(response.data[i].total_cost)
            tmpVar.gst += parseFloat(response.data[i].gst)
            tmpVar.grand_total += parseFloat(response.data[i].grand_total)
          }
          this.projectBillingList.push({
            serial_no: null,
            proj_id: null,
            proj_name: tmpVar.proj_name,
            manpower_cost: tmpVar.manpower_cost,
            service_cost: tmpVar.service_cost,
            mgmt_fee: tmpVar.mgmt_fee,
            total_cost: tmpVar.total_cost,
            gst: tmpVar.gst,
            grand_total: tmpVar.grand_total,
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadBillingComparison (curRec) {
      this.projectBill.proj_name = curRec.proj_name
      var curDate = new Date(this.lbilling_monthAndYear)
      curDate.setDate(1)
      var qry = {
        params: {
          proj_id: curRec.proj_id,
          vendor_id: config.VENDOR_ID,
          previous_month: new Date(curDate).getMonth() === 0 ? 12 : new Date(curDate).getMonth(),
          previous_year: new Date(curDate).getMonth() === 0 ? new Date(curDate).getFullYear() - 1 : new Date(curDate).getFullYear(),
          current_month: parseInt(this.lbilling_monthAndYear.split('-')[1]),
          current_year: parseInt(this.lbilling_monthAndYear.split('-')[0]),
          next_month: parseInt(this.lbilling_monthAndYear.split('-')[1]) === 12 ? 1 : parseInt(this.lbilling_monthAndYear.split('-')[1]) + 1,
          next_year: parseInt(this.lbilling_monthAndYear.split('-')[1]) === 12 ? new Date(curDate).getFullYear() + 1 : new Date(curDate).getFullYear()
        }
      }
      var tmpVar = {
        staff_role: '',
        role_id: null,
        previous_month_billed_amt: 0,
        current_month_billed_amt: 0,
        next_month_billed_amt: 0,
        first_comparison: 0,
        sec_comparison: 0,
      }
      this.comparisonDataList = []
      this.axios.get(config.API_URL + '/getSelectedMonthComparisonBillingDataBasedOnProjId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.comparisonDataList = response.data
          for (var i = 1; i < response.data.length; i++) {
            tmpVar.previous_month_billed_amt += parseInt(response.data[i].previous_month_billed_amt)
            tmpVar.current_month_billed_amt += parseInt(response.data[i].current_month_billed_amt)
            tmpVar.next_month_billed_amt += parseInt(response.data[i].next_month_billed_amt)
            tmpVar.first_comparison += parseInt(response.data[i].first_comparison)
            tmpVar.sec_comparison += parseInt(response.data[i].sec_comparison)
          }
          this.comparisonDataList.push({
            staff_role: 'Total',
            role_id: null,
            previous_month_billed_amt: tmpVar.previous_month_billed_amt,
            current_month_billed_amt: tmpVar.current_month_billed_amt,
            next_month_billed_amt: tmpVar.next_month_billed_amt,
            first_comparison: tmpVar.first_comparison,
            sec_comparison: tmpVar.sec_comparison,
          })
          this.projectBill.prev_comp = ((tmpVar.current_month_billed_amt / tmpVar.previous_month_billed_amt) * 100).toFixed(2)
          this.projectBill.next_comp = ((tmpVar.current_month_billed_amt / tmpVar.next_month_billed_amt) * 100).toFixed(2)
          this.projectBill.prev_month = this.comparisonDataList[0].previous_month_billed_amt
          this.projectBill.next_month = this.comparisonDataList[0].next_month_billed_amt
          this.projectBill.current_month = this.comparisonDataList[0].current_month_billed_amt
          this.projectBill.previous_month_billed_amt = tmpVar.previous_month_billed_amt
          this.projectBill.current_month_billed_amt = tmpVar.current_month_billed_amt
          this.projectBill.next_month_billed_amt = tmpVar.next_month_billed_amt
        } else {
          this.comparisonDataList = []
        }
        this.showComparisonData = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadDetailInfoForselectedProj (curRec) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          proj_contract_base_id: curRec.proj_contract_base_id,
          contract_end_date: handy.formatDBDate(curRec.contract_end_date)
        }
      }
      var tmpVar = {
        serial_no: null,
        staff_role: '',
        head_count: 0,
        amount: 0,
        mgmt_fee_amt: 0,
        before_gst_amt: 0,
        gst_amt: 0,
        total_amt: 0
      }
      this.detailInfoForSelectedProj = []
      this.axios.get(config.API_URL + '/getDetailInfoForselectedProj/', qry)
      .then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.detailInfoForSelectedProj.push({
            serial_no: i+1,
            staff_role: response.data[i].staff_role,
            head_count: response.data[i].head_count,
            amount: response.data[i].amount,
            mgmt_fee_amt: response.data[i].Mgmt_fee_amt,
            before_gst_amt: response.data[i].before_gst_amt,
            gst_amt: response.data[i].gst_amt,
            total_amt: response.data[i].total_amt
          })
          tmpVar.staff_role = 'Total'
          tmpVar.head_count += parseFloat(response.data[i].head_count ? response.data[i].head_count : 0)
          tmpVar.amount += parseFloat(response.data[i].amount)
          tmpVar.mgmt_fee_amt += parseFloat(response.data[i].Mgmt_fee_amt ? response.data[i].Mgmt_fee_amt : 0)
          tmpVar.before_gst_amt += parseFloat(response.data[i].before_gst_amt)
          tmpVar.gst_amt += parseFloat(response.data[i].gst_amt ? response.data[i].gst_amt : 0)
          tmpVar.total_amt += parseFloat(response.data[i].total_amt)
        }
        this.detailInfoForSelectedProj.push(tmpVar)
        this.detailInfo.proj_name = curRec.proj_name
        this.detailInfo.contract_end_date = handy.formatDBDate(curRec.contract_end_date)
        this.showDetailInfo = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    UniformTrackingMetricsFirstLoad () {
      this.lAction = 'uniform-metrics'
      this.loadUniformPurVsDistTrend()
      this.loadUniformTop10ProjDistribution()
      this.loadUniformTop10SubCatDistribution()
    },
    loadUniformMetricsData () {
      this.loadUniformPurVsDistTrend()
      this.loadUniformTop10ProjDistribution()
      this.loadUniformTop10SubCatDistribution()
    },
    loadUniformPurVsDistTrend () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformPurVsDistTrend/', qry)
      .then(response => {
        this.chartDataForUniformPurVsDistTrend = response.data
        document.getElementById('div_uniformPurVsDistTrend').innerHTML = '<canvas id="chart_uniformPurVsDistTrend"></canvas>'
        var canvas = document.getElementById('chart_uniformPurVsDistTrend')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 200
        //ctx.beginPath()
        //ctx.setLineDash([5, 10])
        //ctx.moveTo(0, 50)
        //ctx.lineTo(300, 50)
        //ctx.stroke()
        this.tmpChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: this.chartDataForUniformPurVsDistTrend.map(rec =>rec.monthyear),
            datasets: [{
              label: 'Total Purchase',
              data: this.chartDataForUniformPurVsDistTrend.map(rec =>rec.tot_purchase),
              borderWidth: 3,
              backgroundColor: '#FFA726', //'#EF5350', //'#EEEEEE',
              borderColor: '#FFA726', //'#EF5350', //"#BDBDBD",
              lineTension: 0,
              fill: true
            },
            {
              label: 'Total Distribution',
              data: this.chartDataForUniformPurVsDistTrend.map(rec =>rec.tot_distribution),
              borderWidth: 3,
              backgroundColor: '#9CCC65', //'#BDBDBD',
              borderColor: "#9CCC65",
              lineTension: 0,
              fill: true
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            interaction: {
              mode: 'index',
              intersect: false,
            },
            stacked: false,
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return '' //return 'value' || ''
                },
                color: '#000000',
                fontSize: 11,
              }
            },
            tooltips: {
              enabled: true,
              mode: 'label'
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: false,
                fontColor: "white",
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  beginAtZero: true,
                  min: 0,
                  fontColor: '#ffffff'
                },
                grid: {
                  display: true,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "success"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: true,
                  offset: true
                },
                gridLines: {
                  lineWidth: 1,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff",
                  zeroLineWidth: 0.2
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadUniformTop10ProjDistribution () {
      var qry = {
        params: {
          from_date: this.lDateUniformFrom,
          to_date: this.lDateUniformTo,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformTop10ProjDistribution/', qry)
      .then(response => {
        this.chartDataForTop10ProjectDistribution = response.data
        document.getElementById('div_uniformDistTrendTop10Projects').innerHTML = '<canvas id="chart_uniformDistTrendTop10Projects"></canvas>'
        var canvas = document.getElementById('chart_uniformDistTrendTop10Projects')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 250
        // ctx.beginPath()
        // ctx.setLineDash([5, 10])
        // ctx.moveTo(0, 50)
        // ctx.lineTo(300, 50)
        // ctx.stroke()
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: this.chartDataForTop10ProjectDistribution.map(rec =>rec.proj_name),
            datasets: [{
              borderWidth: 3,
              backgroundColor: '#CFD8DC', //'#880E4F',
              borderColor: '#CFD8DC', // "rgba(219, 0, 0, 1)",
              data: this.chartDataForTop10ProjectDistribution.map(rec =>rec.tot_distribution),
              lineTension: 0,
              fill: false
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return '' //return value || ''
                },
                color: '#ffffff', //'#880E4F',
                fontSize: 0,
              }
            },
            tooltips: {
              enabled: true,
              mode: 'label'
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  beginAtZero: true,
                  min: 0,
                  fontColor: '#ffffff'
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.8,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff",
                  zeroLineWidth: 0.2
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
      .catch(err => {
        this.msg(err)
      })
    },
    loadUniformTop10SubCatDistribution () {
      var qry = {
        params: {
          from_date: this.lDateUniformFrom,
          to_date: this.lDateUniformTo,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformTop10SubCatDistribution/', qry)
      .then(response => {
        this.chartDataForTop10SubCatDistribution = response.data
        document.getElementById('div_uniformDistTrendTop10SubCat').innerHTML = '<canvas id="chart_uniformDistTrendTop10SubCat"></canvas>'
        var canvas = document.getElementById('chart_uniformDistTrendTop10SubCat')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 250
        // ctx.beginPath()
        // ctx.setLineDash([5, 10])
        // ctx.moveTo(0, 50)
        // ctx.lineTo(300, 50)
        // ctx.stroke()
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: this.chartDataForTop10SubCatDistribution.map(rec =>rec.uniform_sub_cat),
            datasets: [{
              borderWidth: 3,
              backgroundColor: '#CFD8DC', //'#880E4F',
              borderColor: '#CFD8DC', // "rgba(219, 0, 0, 1)",
              data: this.chartDataForTop10SubCatDistribution.map(rec =>rec.tot_dist_value),
              lineTension: 0,
              fill: false
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return '' //return value || ''
                },
                color: '#ffffff', //'#880E4F',
                fontSize: 0,
              }
            },
            tooltips: {
              enabled: true,
              mode: 'label'
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  beginAtZero: true,
                  min: 0,
                  fontColor: '#ffffff'
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.8,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#ffffff",
                  zeroLineWidth: 0.2
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })
      })
      .catch(err => {
        this.msg(err)
      })
    },
    BackofficeSupportMetricsFirstLoad () {
      this.lAction = 'backoffice-metrics'
      this.getBODashDeptName()
    },
    getBODashDeptName () {
      var qry = {
        params: {
          from_date: this.lDateBOFrom,
          to_date: this.lDateBOTo,
          vendor_id: config.VENDOR_ID
        }
      }
      this.BODashDeptWise = []
      this.axios.get(config.API_URL + '/getBODashDeptName/', qry)
      .then(response => {
        this.BODashDeptWise = response.data
        this.loadBODashDeptWise()
      })
      .catch(err => {
        this.BODashDeptWise = []
        this.msg(err, 0)
      })
    },
    loadBODashDeptWise () {
      var qry = {
        params: {
          from_date: this.lDateBOFrom,
          to_date: this.lDateBOTo,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getBODashDeptWiseChart/', qry)
      .then(response => {
        var tmpVar = response.data
        for (var i = 0; i < this.BODashDeptWise.length; i++) {
          var listBasedOnDept = []
          listBasedOnDept = tmpVar.filter(rec => rec.dept_name === this.BODashDeptWise[i].dept_name)
          document.getElementById('div_chartBODashDeptWise_' + this.BODashDeptWise[i].dept_name.split(' ').join('_')).innerHTML = '<canvas id="chart_chartBODashDeptWise_' + this.BODashDeptWise[i].dept_name.split(' ').join('_') + '"></canvas>'
          var canvas = document.getElementById('chart_chartBODashDeptWise_' + this.BODashDeptWise[i].dept_name.split(' ').join('_'))
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 250
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: listBasedOnDept.map(rec => rec.monthyear),
              datasets: [{
                label: 'Total Raised',
                data: listBasedOnDept.map(rec => rec.tot_ticket),
                borderWidth: 3,
                backgroundColor: '#FFA726', //'#EEEEEE',
                borderColor: '#FFA726', //"#BDBDBD",
                lineTension: 0,
                fill: false
              },
              {
                label: 'Opened Tickets',
                data: listBasedOnDept.map(rec => rec.open_ticket),
                borderWidth: 3,
                backgroundColor: '#9CCC65', //'#BDBDBD',
                borderColor: "#9CCC65",
                lineTension: 0,
                fill: false
              },
              {
                label: 'Closed Tickets',
                data: listBasedOnDept.map(rec => rec.closed_ticket),
                borderWidth: 3,
                backgroundColor: '#ccc966', //'#BDBDBD',
                borderColor: "#ccc966",
                lineTension: 0,
                fill: false
              },
              {
                label: 'New Tickets',
                data: listBasedOnDept.map(rec => rec.new_ticket),
                borderWidth: 3,
                backgroundColor: '#66ccc7', //'#BDBDBD',
                borderColor: "#66ccc7",
                lineTension: 0,
                fill: false
              },
              {
                label: 'Job Done Tickets',
                data: listBasedOnDept.map(rec => rec.job_done_ticket),
                borderWidth: 3,
                backgroundColor: '#c766cc', //'#BDBDBD',
                borderColor: "#c766cc",
                lineTension: 0,
                fill: false
              },
              {
                label: 'On-Hold Tickets',
                data: listBasedOnDept.map(rec => rec.on_hold_ticket),
                borderWidth: 3,
                backgroundColor: '#cc667d', //'#BDBDBD',
                borderColor: "#cc667d",
                lineTension: 0,
                fill: false
              },
              {
                label: 'UnAssigned Tickets',
                data: listBasedOnDept.map(rec => rec.unassigned_ticket),
                borderWidth: 3,
                backgroundColor: '#1c79d4', //'#BDBDBD',
                borderColor: "#1c79d4",
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: '#ffffff', //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontColor: 'White',
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: '#ffffff'
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: "white",
                    zeroLineColor: "#ffffff"
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: '#ffffff',
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: "white",
                    zeroLineColor: "#ffffff",
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadBackOfficeMetricsData () {
      this.getBODashDeptName()
    },
    empAttritionMetrics () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.loadMaleFemaleChartData()
      this.loadTotalStaffBasedOnRoleCatForChartData()
      this.chartDataForTotalEmp = []
      this.chartDataForTotalNewEmpAndLeftEmp = []
      this.axios.get(config.API_URL + '/getChartDataForLeftEmployee/', qry)
      .then(response => {
        this.chartDataForTotalEmp = response.data
        setTimeout(() => {
          document.getElementById('div_chartDataForTotalEmp').innerHTML = '<canvas id="chart_chartDataForTotalEmp"></canvas>'
          var canvas = document.getElementById('chart_chartDataForTotalEmp')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = '#fff'
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.chartDataForTotalEmp.map(rec =>rec.monthyear),
              datasets: [{
                borderWidth: 3,
                backgroundColor: '#FFA726', //'#880E4F',
                borderColor: '#FFA726', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForTotalEmp.map(rec =>rec.left_emp_percet),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
        setTimeout(() => {
          for (var i = 0; i < response.data.length; i++) {
            this.chartDataForTotalNewEmpAndLeftEmp[i] = []
          }
          for (var i = 0; i < response.data.length; i++) {
            this.chartDataForTotalNewEmpAndLeftEmp[0][i] = response.data[i].tot_emp - response.data[i].tot_emp_left
            this.chartDataForTotalNewEmpAndLeftEmp[1][i] = response.data[i].tot_emp_left
          }
          var dsets = []
          var lColor = ['#FFA726', '#9CCC65']
          var label = ['New Emp', 'Left Emp']
          for (var i = 0; i < 2; i++) {
            dsets[i] = {
              label: label[i],
              borderWidth: 1,
              backgroundColor: lColor[i], //'#880E4F',
              borderColor: '#ffffff', // "rgba(219, 0, 0, 1)",
              data: this.chartDataForTotalNewEmpAndLeftEmp[i],
              lineTension: 0,
              fill: false
            }
          }
          document.getElementById('div_chartDataForTotalNewEmpAndLeftEmp').innerHTML = '<canvas id="chart_chartDataForTotalNewEmpAndLeftEmp"></canvas>'
          var canvas = document.getElementById('chart_chartDataForTotalNewEmpAndLeftEmp')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = "#fff"
          this.tmpChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: this.chartDataForTotalEmp.map(rec =>rec.monthyear),
              datasets: dsets
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  usePointStyle: false,
                  fontColor: "white",
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
        this.lAction = 'tot-emp'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadMaleFemaleChartData () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.chartDataForTotalMaleFemale = []
      this.axios.get(config.API_URL + '/getChartDataFortotalMaleAndFemale/', qry)
      .then(response => {
        if (response.data.length > 0) {
          var tmpVar = []
          var totStaff = response.data[0].tot_male + response.data[0].tot_female
          tmpVar.push(((response.data[0].tot_male / totStaff) * 100).toFixed(0))
          tmpVar.push(((response.data[0].tot_female / totStaff) * 100).toFixed(0))
          this.chartDataForTotalMaleFemale.push(response.data[0].tot_male)
          this.chartDataForTotalMaleFemale.push(response.data[0].tot_female)
          setTimeout(() => {
            document.getElementById('div_chartDataForTotalMaleFemale').innerHTML = '<canvas id="chart_chartDataForTotalMaleFemale"></canvas>'
            var canvas = document.getElementById('chart_chartDataForTotalMaleFemale')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = 295
            this.tmpChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Male', 'Female'],
                datasets: [{
                  backgroundColor: ['#FFA726', '#9CCC65'],
                  data: this.chartDataForTotalMaleFemale
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value > 0 ? value : ''
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  fontSize: 16
                },
                legend: {
                  position: 'bottom',
                  labels: {
                    usePointStyle: false,
                    fontColor: "white",
                    fontSize: 11
                  }
                }
              }
            })
          }, 500)
          setTimeout(() => {
            document.getElementById('div_chartDataForTotalMaleFemalePercentage').innerHTML = '<canvas id="chart_chartDataForTotalMaleFemalePercentage"></canvas>'
            var canvas = document.getElementById('chart_chartDataForTotalMaleFemalePercentage')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = 295
            this.tmpChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Male', 'Female'],
                datasets: [{
                  backgroundColor: ['#FFA726', '#9CCC65'],
                  data: tmpVar
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value > 0 ? value + ' % ' : ''
                    },
                    color: '#fff'
                  }
                },
                title: {
                  display: true,
                  fontSize: 16
                },
                legend: {
                  position: 'bottom',
                  labels: {
                    usePointStyle: false,
                    fontColor: "white",
                    fontSize: 11
                  }
                }
              }
            })
          }, 500)
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadTotalStaffBasedOnRoleCatForChartData () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.chartDataForTotalStaffBasedOnRoleCat = []
      this.axios.get(config.API_URL + '/getTotalStaffBasedOnRoleCatForChartData/', qry)
      .then(response => {
        this.chartDataForTotalStaffBasedOnRoleCat = response.data
        setTimeout(() => {
          document.getElementById('div_chartDataForTotalEmpBasedOnRoleCat').innerHTML = '<canvas id="chart_chartDataForTotalEmpBasedOnRoleCat"></canvas>'
          var canvas = document.getElementById('chart_chartDataForTotalEmpBasedOnRoleCat')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = "#fff"
          this.tmpChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: this.chartDataForTotalStaffBasedOnRoleCat.map(rec =>rec.role_cat),
              datasets: [{
                borderWidth: 1,
                backgroundColor: '#9CCC65', //'#880E4F',
                borderColor: '#FFA726', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForTotalStaffBasedOnRoleCat.map(rec =>rec.tot_emp),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    goBack () {
      this.empAttritionMetrics()
    },
    loadCategoryWiseAttrition () {
      this.loadSoftServicesAttrition()
      this.loadTechnicalAttrition()
      this.loadSafetyAttrition()
      this.loadOtherAttrition()
      document.getElementById('div_chartDataForTotalMaleFemale').innerHTML = '<canvas id="chart_chartDataForTotalMaleFemale"></canvas>'
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getLeftAndNewEmpForChartData/', qry)
      .then(response => {
        this.chartDataForLeftAndNewEmp = response.data
        var color = '#fff'
        setTimeout(() => {
          document.getElementById('div_chartDataForLeftAndNewEmpofManagement').innerHTML = '<canvas id="chart_chartDataForLeftAndNewEmpofManagement"></canvas>'
          var canvas = document.getElementById('chart_chartDataForLeftAndNewEmpofManagement')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.chartDataForLeftAndNewEmp.map(rec =>rec.monthyear),
              datasets: [{
                borderWidth: 3,
                backgroundColor: '#FFA726', //'#880E4F',
                borderColor: '#FFA726', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForLeftAndNewEmp.map(rec => rec.left_emp_percet),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
        this.lAction = 'category-Attrition'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadSoftServicesAttrition () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getTotalEmpLeftofSoftServiceForChartData/', qry)
      .then(response => {
        this.chartDataForLeftEmpOfSoftService = response.data
        setTimeout(() => {
          document.getElementById('div_chartDataForLeftEmpofSoft').innerHTML = '<canvas id="chart_chartDataForLeftEmpofSoft"></canvas>'
          var canvas = document.getElementById('chart_chartDataForLeftEmpofSoft')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = '#fff'
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.chartDataForLeftEmpOfSoftService.map(rec =>rec.monthyear),
              datasets: [{
                borderWidth: 3,
                backgroundColor: '#9CCC65', //'#880E4F',
                borderColor: '#9CCC65', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForLeftEmpOfSoftService.map(rec => rec.left_emp_percet),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadTechnicalAttrition () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getTotalEmpLeftofTechServiceForChartData/', qry)
      .then(response => {
        this.chartDataForLeftEmpOfTechService = response.data
        setTimeout(() => {
          document.getElementById('div_chartDataForLeftEmpofTech').innerHTML = '<canvas id="chart_chartDataForLeftEmpofTech"></canvas>'
          var canvas = document.getElementById('chart_chartDataForLeftEmpofTech')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = '#fff'
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.chartDataForLeftEmpOfTechService.map(rec =>rec.monthyear),
              datasets: [{
                borderWidth: 3,
                backgroundColor: '#FFA726', //'#880E4F',
                borderColor: '#FFA726', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForLeftEmpOfTechService.map(rec => rec.left_emp_percet),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadSafetyAttrition () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getTotalEmpLeftofSafetyServiceForChartData/', qry)
      .then(response => {
        this.chartDataForLeftEmpOfSafetyService = response.data
        setTimeout(() => {
          document.getElementById('div_chartDataForLeftEmpofSafety').innerHTML = '<canvas id="chart_chartDataForLeftEmpofSafety"></canvas>'
          var canvas = document.getElementById('chart_chartDataForLeftEmpofSafety')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = '#fff'
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.chartDataForLeftEmpOfSafetyService.map(rec =>rec.monthyear),
              datasets: [{
                borderWidth: 3,
                backgroundColor: '#9CCC65', //'#880E4F',
                borderColor: '#9CCC65', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForLeftEmpOfSafetyService.map(rec => rec.left_emp_percet),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadOtherAttrition () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getTotalEmpLeftofOtherServiceForChartData/', qry)
      .then(response => {
        this.chartDataForLeftEmpOfOtherService = response.data
        setTimeout(() => {
          document.getElementById('div_chartDataForLeftEmpofOther').innerHTML = '<canvas id="chart_chartDataForLeftEmpofOther"></canvas>'
          var canvas = document.getElementById('chart_chartDataForLeftEmpofOther')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          var color = '#fff'
          this.tmpChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.chartDataForLeftEmpOfOtherService.map(rec =>rec.monthyear),
              datasets: [{
                borderWidth: 3,
                backgroundColor: '#FFA726', //'#880E4F',
                borderColor: '#FFA726', // "rgba(219, 0, 0, 1)",
                data: this.chartDataForLeftEmpOfOtherService.map(rec => rec.left_emp_percet),
                lineTension: 0,
                fill: false
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return '' //return value || ''
                  },
                  color: color, //'#880E4F',
                  fontSize: 0,
                }
              },
              tooltips: {
                enabled: true,
                mode: 'label'
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: color
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: color,
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.8,
                    display: true,
                    borderDash: [1, 2],
                    color: color,
                    zeroLineColor: color,
                    zeroLineWidth: 0.2
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    ProjectUnBilledMetrics () {
      this.projectUnBilledList = []
      this.lUnBilled_monthAndYear = this.lbilling_monthAndYear
      this.lAction = 'Unbilled-metrics'
      if (this.lUnBilled_monthAndYear) {
        this.loadUnBilledProjectList()
      }
    },
    loadUnBilledProjectList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          billing_month: this.lUnBilled_monthAndYear.split('-')[1],
          billing_year: this.lUnBilled_monthAndYear.split('-')[0]
        }
      }
      var tmpVar = {
        proj_name: '',
        manpower_cost: 0,
        service_cost: 0,
        mgmt_fee: 0,
        total_cost: 0,
        gst: 0,
        grand_total: 0,
      }
      this.projectUnBilledList = []
      this.axios.get(config.API_URL + '/getProjectUnBilledList/', qry)
      .then(response => {
        if (response.data.length > 0) {
          for (var i = 0; i < response.data.length; i++) {
            this.projectUnBilledList.push({
              serial_no: i+1,
              proj_id: response.data[i].proj_id,
              proj_name: response.data[i].proj_name,
              bill_no: response.data[i].bill_no,
              billing_status: response.data[i].billing_status,
              manpower_cost: response.data[i].manpower_cost,
              service_cost: response.data[i].service_cost,
              mgmt_fee: response.data[i].Mgmt_fee,
              total_cost: response.data[i].total_cost,
              gst: response.data[i].gst,
              grand_total: response.data[i].grand_total
            })
            tmpVar.proj_name = 'Total'
            tmpVar.manpower_cost += parseFloat(response.data[i].manpower_cost)
            tmpVar.service_cost += parseFloat(response.data[i].service_cost)
            tmpVar.mgmt_fee += parseFloat(response.data[i].Mgmt_fee)
            tmpVar.total_cost += parseFloat(response.data[i].total_cost)
            tmpVar.gst += parseFloat(response.data[i].gst)
            tmpVar.grand_total += parseFloat(response.data[i].grand_total)
          }
          this.projectUnBilledList.push({
            serial_no: null,
            proj_id: null,
            proj_name: tmpVar.proj_name,
            bill_no: null,
            billing_status: null,
            manpower_cost: tmpVar.manpower_cost,
            service_cost: tmpVar.service_cost,
            mgmt_fee: tmpVar.mgmt_fee,
            total_cost: tmpVar.total_cost,
            gst: tmpVar.gst,
            grand_total: tmpVar.grand_total,
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    PPMSummaryMetrics () {
      this.loadCommunity()
      this.loadClosedProjectCommunity()
      this.PPMSummaryList = []
      this.lAction = 'ppmsummary-metrics'
    },
    loadPPMSummaryBasedOnComm (curComm) {
      var qry = {
        params: {
          comm_id: curComm
        }
      }
      this.ppmSummaryList = []
      this.axios.get(config.API_URL + '/getPPMSummaryListForCommunity/', qry)
      .then(response => {
        this.ppmSummaryList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    }
  }
}
</script>
